import React from "react";
import { errorStatus } from "../Actions/Utility";
import { connect } from "react-redux";
import { BlockStack, Card, Text } from "@shopify/polaris";
import * as Sentry from "@sentry/react";

type errorType = "fullPage" | "modulePage" | "";
class ErrorBoundary extends React.Component<any, any> {
  static readonly props: any;
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(error: any) {
    //console.log(error, "getDerivedStateFromError");

    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any) {
    //console.log(error.toString(), this.props.errorType, "getDerivedStateFromError");

    this.props.error(error.toString(), this.props.errorType);

    // You can also log the error to an error reporting service
    this.setState({ message: error.toString() });
    Sentry.captureException(error);
  }

  render() {
    const { message } = this.state;

    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "50vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f6f6f7",
          }}
        >
          <Card padding="600">
            <BlockStack gap="500">
              <Text as="h2" variant="headingLg">
                Oops! Something went wrong.
              </Text>
              <div
                style={{ textAlign: "center", maxWidth: 400, margin: "0 auto" }}
              >
                <Text as="p" tone="subdued">
                  {message !== ""
                    ? message
                    : "An unexpected error occurred. Please try again or contact support."}
                </Text>
              </div>
              <div style={{ marginTop: 24, textAlign: "center" }}>
                <button
                  className="inte-btn inte__plain-btn inte-plain-dark-btn"
                  style={{
                    padding: "10px 28px",
                    fontSize: 16,
                    borderRadius: 8,
                    background: "#008060",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    transition: "background 0.2s",
                  }}
                  onClick={() => {
                    this.props.history(-1);
                  }}
                >
                  <span className="inte__text">Go Back</span>
                </button>
              </div>
            </BlockStack>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

function mapStateToProps(dispatch: any, state: any) {
  return {
    error: (message: string, errorType: errorType) =>
      dispatch(errorStatus(window.location.href, true, errorType, message)),
  };
}

export default connect(null, mapStateToProps)(ErrorBoundary);
